import { render, staticRenderFns } from "./TextInviteHistory.vue?vue&type=template&id=2028395c&"
import script from "./TextInviteHistory.vue?vue&type=script&lang=js&"
export * from "./TextInviteHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports